export const CHER_LINK_IMAGE_URL =
  "https://bandnada.s3.amazonaws.com/static/external_assets/web/bandnada_cher_pic.png"

export const PLAYLIST_PLACEHOLDER_IMAGE_URL =
  "https://bandnada.s3.amazonaws.com/static/external_assets/web/bandnada_playlist.png"
